import request from '@/utils/request'

// 查询患者记录列表
export function listUserRecord(query) {
  return request({
    url: '/biz/user-record/list',
    method: 'get',
    params: query
  })
}

// 查询患者记录分页
export function pageUserRecord(query) {
  return request({
    url: '/biz/user-record/page',
    method: 'get',
    params: query
  })
}

// 查询患者记录详细
export function getUserRecord(data) {
  return request({
    url: '/biz/user-record/detail',
    method: 'get',
    params: data
  })
}

// 新增患者记录
export function addUserRecord(data) {
  return request({
    url: '/biz/user-record/add',
    method: 'post',
    data: data
  })
}

// 修改患者记录
export function updateUserRecord(data) {
  return request({
    url: '/biz/user-record/edit',
    method: 'post',
    data: data
  })
}

// 删除患者记录
export function delUserRecord(data) {
  return request({
    url: '/biz/user-record/delete',
    method: 'post',
    data: data
  })
}

// 查询评分统计数据
export function getTopData(data) {
  return request({
    url: '/biz/user-record/getTopData',
    method: 'get',
    params: data
  })
}

